var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconCopy = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "17px",
    viewBox: "0 0 16 17",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Copy") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter-1"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    type: "matrix",
    values: "0 0 0 0 0.278431 0 0 0 0 0.270588 0 0 0 0 0.278431 0 0 0 1.000000 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "API---option-1",
    transform: "translate(-1389.000000, -916.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(940.000000, 904.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    transform: "translate(432.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Copy",
    transform: "translate(13.000000, 8.500000)",
    filter: "url(#filter-1)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M11.5,11 L13,11 L13,12.5 C13,12.8 13.2,13 13.5,13 L14.5,13 C14.8,13 15,12.8 15,12.5 L15,11 L16.5,11 C16.8,11 17,10.8 17,10.5 L17,9.5 C17,9.2 16.8,9 16.5,9 L15,9 L15,7.5 C15,7.2 14.8,7 14.5,7 L13.5,7 C13.2,7 13,7.2 13,7.5 L13,9 L11.5,9 C11.2,9 11,9.2 11,9.5 L11,10.5 C11,10.8 11.2,11 11.5,11 L11.5,11 Z M19,4 L9,4 C8.4,4 8,4.4 8,5 L8,8 L5,8 C4.4,8 4,8.4 4,9 L4,19 C4,19.6 4.4,20 5,20 L15,20 C15.6,20 16,19.6 16,19 L16,16 L19,16 C19.6,16 20,15.6 20,15 L20,5 C20,4.4 19.6,4 19,4 L19,4 Z M14,18 L6,18 L6,10 L8,10 L8,15 C8,15.6 8.4,16 9,16 L14,16 L14,18 L14,18 Z M18,14 L10,14 L10,6 L18,6 L18,14 L18,14 Z",
    id: "Shape",
    fill: "#6E6E6E"
  })))))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconCopy);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Icon-Copy.380f49d90dc313b9c43f611d8fcb0c17.svg";